import {
  GeckoAuthenticationContext,
  GeckoAuthenticationContextType,
} from 'features/auth/geckoAuthContext'
import { useContext } from 'react'

export const useGeckoAuth = (): GeckoAuthenticationContextType => {
  const authnContext = useContext(GeckoAuthenticationContext)
  if (!authnContext)
    throw new Error(
      'useGeckoAuth() must be used within GeckoAuthProvider and GeckoPermissionsProvider'
    )
  return { ...authnContext }
}
